import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/finally';

import { StatisticService } from '../../../../services/statistic.service';
import { UserService } from '../../../../services/user.service';
import { Statistic, User } from '../../../../entities/index';
import { Log } from '../../../../utils/index';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.html'
})
export class DashboardAdminComponent implements OnInit {
  retailerStats: Observable<Statistic[]>;
  loadingRetailer = false;

  statusStats: Observable<Statistic[]>;
  loadingStatus = false;

  typeStats: Observable<Statistic[]>;
  loadingType = false;

  constructor(protected statisticService: StatisticService, protected userService: UserService) {
  }

  @Log()
  ngOnInit() {
    this.watchCurrentUser();
  }

  @Log()
  watchCurrentUser() {
    this.userService.currentUser.subscribe(user => {
      if (user && user.id) {
        this.getRetailerCount(user);
        this.getStatusStats(user);
        this.getTypeStats(user);
      }
    });
  }

  @Log()
  getRetailerCount(user: User = null) {
    this.loadingRetailer = true;
    this.retailerStats = this.statisticService.retailerStats(user).finally(() => this.loadingRetailer = false);
  }

  @Log()
  getStatusStats(user: User = null) {
    this.loadingStatus = true;
    this.statusStats = this.statisticService.statusStats(user).finally(() => this.loadingStatus = false);
  }

  @Log()
  getTypeStats(user: User = null) {
    this.loadingType = true;
    this.typeStats = this.statisticService.typeStats(user).finally(() => this.loadingType = false);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/dashboard/admin/dashboard-admin.component.ts